import React from 'react'
import VideoCards from '@/components/VideoCards'
import Section from '@/components/Section'
import SectionHeader from '@/components/SectionHeader'
import SectionSubHeading from '@/components/SectionSubHeading'
import { localizeCenterToCentre } from '../../../utils/localizeCenter'
import useLinkProps from '@/hooks/useLinkProps'
import { fixBlogUrls } from '../../../utils/replaceWith'
import NearbyCities from '../NearbyCities'
import { shouldShowInternationalVideoCards } from '../../../domain/destinations/useCases/shouldShowInternationalVideoCards'
import { getTermHeader } from '../../../domain/term/headerMappings/getTermHeader'
import { CustomHeaderType } from '../../../domain/term/headerMappings/constants'
import { isLocationPageType } from '../../../domain/useCases/pageTypeCheck'
import MoreAboutContentSection from './MoreAboutContentSection'
import { ArrowRight, ChevronRight } from 'react-bootstrap-icons'
import IconWithLink from '@/components/IconWithLink'
import LinkButton from '../../atoms/LinkButton/LinkButton'

export const TermList = ({ items, createURL }) => {
  return (
    <div>
      {items.slice(0, 3).map((item) => {
        return (
          <a
            style={{ fontWeight: item.isRefined ? 'bold' : '' }}
            href={createURL([item.value])}
            key={item.label}
          >
            {item.label}
          </a>
        )
      })}
    </div>
  )
}
/* pageData can be a location or a term */
export const BrowseFAQs = ({
  quick_links,
  pageType,
  termData,
  shouldDefaultRegionalize = false,
  pageData,
  data,
  customTermHeader
}) => {
  const { description, title = '' } = pageData

  const descriptionToUse = termData.description
    ? termData.description
    : description
  const regionalizedText =
    shouldDefaultRegionalize && descriptionToUse
      ? localizeCenterToCentre(descriptionToUse)
      : descriptionToUse
  const regionalizedDescriptionWithRelativePaths = fixBlogUrls(regionalizedText)

  const shouldDisplayTopDestinations = isLocationPageType(pageType)

  const descriptionBoxHeader = getTermHeader({
    pageType,
    title,
    termTitle: termData.title,
    customTermHeader,
    headerType: CustomHeaderType.DESCRIPTION_BOX
  })

  const showInternationalCards = shouldShowInternationalVideoCards({
    pageType,
    document: pageData
  })

  return (
    <div className="flex flex-col gap-10 md:gap-12">
      <Section>
        {/* location faqs */}
        <div className="flex flex-col gap-9 pb-12">
          {descriptionToUse && (
            <MoreAboutContentSection
              header="Recovery Guide"
              title={descriptionBoxHeader}
              content={regionalizedDescriptionWithRelativePaths}
            />
          )}

          {/* drug addiction faqs */}
          {isLocationPageType(pageType) && (
            <MoreAboutContentSection
              header="Recovery Guide"
              title="Addiction & Rehab"
              content={data?.term?.description}
            />
          )}
        </div>
        {quick_links.length > 0 && (
          <div className="flex flex-col gap-6">
            <div className="font-FieldsVariable text-2xl font-medium text-gray-1100">
              Learn More
            </div>
            <div className="rounded-2xl border-gray-200 md:border md:px-6 md:py-2">
              {quick_links.map(({ link, label }) => (
                <a
                  href={fixBlogUrls(link)}
                  className="group flex w-full justify-start border-b border-gray-200 py-4 first:pt-0 md:py-3 first:md:pt-3 md:last:border-b-0"
                  key={link}
                >
                  <div className="flex w-full items-center justify-start gap-4 md:gap-3">
                    <div>
                      <div className="flex size-9 items-center justify-center gap-2 rounded-xl bg-primary-25 p-2">
                        <IconWithLink className="text-gray-1100 lg:size-6" />
                      </div>
                    </div>
                    <div className="flex h-11 w-full items-center gap-4 group-hover:underline">
                      <div className="w-full">{label}</div>
                      <div>
                        <ChevronRight />
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}
      </Section>

      {isLocationPageType(pageType) && data?.location && (
        <NearbyCities
          location={data.location}
          locationAllowList={data.locationAllowList.allowedLocations}
          pageType={pageType}
        />
      )}

      {shouldDisplayTopDestinations && (
        <Section>
          <SectionHeader>
            <h3 className="font-FieldsVariable text-lg font-medium leading-6 text-gray-1100">
              Explore Top Treatment Destinations
            </h3>
            <SectionSubHeading tag="p">
              Residential rehab offers you or your loved one the opportunity to
              start anew in a setting tailored to your needs. With a variety of
              available options, one is sure to be perfect for you.
            </SectionSubHeading>
          </SectionHeader>
          <VideoCards showInternationalCards={showInternationalCards} />

          <div className="inline-block pt-2">
            <LinkButton
              label="Watch the full series"
              href="/destinations/"
              size="large"
              underline="always"
              iconElement={
                <ArrowRight
                  size="16"
                  className="ml-1"
                />
              }
            />
          </div>
        </Section>
      )}
    </div>
  )
}
